import {t} from '@lingui/macro';
import {addLine, updateLine} from 'api/api.js';
import {setState} from 'config/Core.js';
import React from 'react';
import Routes from 'router/routes.js';
import DV from 'variables/DV.js';
import Button from '../../MUI_Kit/components/CustomButtons/Button';
import CustomInput from '../../MUI_Kit/components/CustomInput/CustomInput';
import BaseModal from '../BaseComponent/BaseModal';
import {handleApi} from 'helper/helper';

class LineModal extends BaseModal {
  constructor(props) {
    super(props);
    let params = this.getDataFromRouter();
    if (!params) this.redirectTo(Routes.channel.path);

    this.state = {
      open: true,
      title: this.getTitle(),
      loading: false,
      channel_id: params?.metadata?.channel_id ?? '',
      channel_secret: '',
      access_token: '',
      webhook_url: params?.metadata?.webhook_url ?? '',
      ...params,
    };

    this.goPathWhenClose = !this.props.openFromChannels ? Routes.channel.path : Routes.channel.path;
  }

  getTitle() {
    if (this.state.id) return t`Cập nhật kênh Line`;
    else return t`Thêm kênh Line`;
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value.trim(),
    });
  };

  renderBody() {
    const {id, channel_id, channel_secret, access_token, webhook_url} = this.state;

    return (
      <form>
        <CustomInput
          labelText={t`Channel ID`}
          required
          inputProps={{
            disabled: !!id,
            placeholder: t`Nhập vào Channel ID`,
            type: 'text',
            value: channel_id || '',
            onChange: this.handleChange('channel_id'),
          }}
        />
        <CustomInput
          labelText={t`Channel Secret`}
          required
          inputProps={{
            placeholder: t`Nhập vào Channel Secret`,
            type: 'text',
            value: channel_secret || '',
            onChange: this.handleChange('channel_secret'),
          }}
        />
        <CustomInput
          labelText={t`Access Token`}
          required
          inputProps={{
            placeholder: t`Nhập vào Access Token`,
            type: 'text',
            value: access_token || '',
            onChange: this.handleChange('access_token'),
          }}
        />
        {!!id && <CustomInput
          labelText={t`Webhook URL`}
          inputProps={{
            disabled: true,
            type: 'text',
            value: webhook_url || '',
          }}
        />}
      </form>
    );
  };

  update = async (payload, id) => {
    this.setState({loading: true});
    let {success, error, data} = await handleApi(updateLine(id, payload));
    this.setState({loading: false});

    if (error) {
      DV.showNotify(error, 'danger');
      return {error};
    }
    if (success) {
      this.refreshOnClose = true;
      DV.showNotify(t`Cập nhật thành công`);
      return {success: true};
    }
  };

  add = async ({channel_id, channel_secret, access_token}) => {
    await setState(this)({loading: true});
    let {success, data, error} = await handleApi(
      addLine(
        {
          channel_id,
          channel_secret,
          access_token,
        },
        DV.company.id,
      ),
    );
    await setState(this)({loading: false});

    if (error) {
      DV.showNotify(error, 'danger');
      return {error};
    }
    if (success) {
      this.refreshOnClose = true;
      DV.showNotify(t`Thêm thành công`);
      return {success: true};
    }
  };

  validate = () => {
    const {channel_id, channel_secret,access_token} = this.state;
    return channel_id && channel_id !== '' && channel_secret && channel_secret !== '' && access_token && access_token !== '';
  };

  handleSubmit = async () => {
    const {id, channel_id, channel_secret, access_token} = this.state;
    let res = id ? await this.update({channel_id, channel_secret, access_token}, id) : await this.add({channel_id, channel_secret, access_token});

    if (res && res.success) {
      this.close(true);
    }
  };

  renderFooter() {
    const {loading} = this.state;
    return [
      <Button onClick={this.handleSubmit} color="info" loading={loading}>
        {t`Hoàn tất`}
      </Button>,
    ];
  }
}

export default LineModal;
